module.exports = __webpack_public_path__ + "static/media/Tecweigh-logo.b1a15874.jpg";